import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=2e819d62"
import script from "./Instructions.vue?vue&type=script&lang=ts"
export * from "./Instructions.vue?vue&type=script&lang=ts"
import style0 from "./Instructions.vue?vue&type=style&index=0&id=2e819d62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports